import React, {lazy, Suspense} from 'react'
import LoadingPage from "../views/LoadingPage";

export const createLazyComponent = (
    promise,
    fallback = <LoadingPage/>,
    name,
) => {
    const LazyComponent = lazy(promise)
    const Component = props => (
        <Suspense fallback={fallback}>
            <LazyComponent {...props} />
        </Suspense>
    )
    Component.displayName = `nest(Suspense,lazy(${name ||
    'Component'}))`
    return Component
}
